/* @flow */
/* eslint-disable camelcase */
// maps link relations to handler function names
// for example:
//    "next" : "DiscGolf"
//
//    will result in links with the relation "next"
//    getting parsed by a method called parseLinksDiscGolf

const Rel = {
  acknowledge: "Acknowledge",
  commit: "Commit", // save a schema to the server
  child: "Child",
  "child-schema": "ChildSchema", // schema for an item in a collection
  clear: "Clear", // clear a single alert
  clear_all: "ClearAll", // clear all alerts
  edit: "Edit", // edit an existing resource
  filter: "Filter", // filter a collection
  filter_events: "FilterEvents",
  filter_videos: "FilterVideos",
  image: "Image", // an image url
  "nexia:history": "History",
  next: "Next", // next in a series of items
  previous: "Previous",
  page: "Page", // a templated link to a page on a collection
  self: "Self",
  template: "Template", // TODO: remove, seems to duplicate child-schema
  parent: "Parent",
  operation: "Operation", // an arbitrary action with a human-readable title
  automate: "Automate", // a resource that can help automate the linking resource
  details: "Details", // further information for a resource
  video_url: "VideoURL", // video stream URL
  stream: "Stream", // event stream
  pending_request: "PendingRequest", // some additional data associated with the model that is incoming
};

export type LinkRelationName = $Keys<typeof Rel>;

export default Rel;



// WEBPACK FOOTER //
// ./src/framework/rel.js